import { Flex } from "@/atoms"
import { isTerminatedApplication } from "@/domain/application/application"
import { InfoCircleOutlined } from "@/icons"
import { MoreTableCellDrawer } from "@/pages/DiscoveryPage/components/molecules/MoreTableCellDrawer"

import type { RowClick } from "@/hooks/useLinkDrawerTooltip"
import type { TFunction } from "@/hooks/useTranslation"
import type { MoreTableCellProps } from "@/molecules/MoreTableCell"

export const RelatedImagesCell = (t: TFunction, onRowClick: RowClick) => {
  const renderRelatedImages = MoreTableCellDrawer(onRowClick)

  return function RelatedImagesCellComponent(
    value: Omit<MoreTableCellProps, "onRowClick">,
    record: { workloadStatus?: string }
  ) {
    const isTerminated = isTerminatedApplication(record.workloadStatus)

    if (isTerminated)
      return (
        <Flex align="center" gap={4}>
          {t("inventory.application.terminatedWarning")}
          <InfoCircleOutlined
            data-tooltip-content={t(
              "inventory.application.terminatedWarningTooltip"
            )}
          />
        </Flex>
      )

    return renderRelatedImages(value)
  }
}
